module.exports = "<h4 class=\"sub-heading\">Notable projects</h4>\n<h6 class=\"sub-heading-2\">These are just few from my complete portfolio, <a href=\"https://github.com/makaravind\"\n                                                                            class=\"more-link\">click here for more</a>\n</h6>\n<div class=\"project-list\">\n  <app-project-item *ngFor=\"let projectIter of projects\" [project]=\"projectIter\"></app-project-item>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/app/displayer/projects/projects.component.html
// module id = ../../../../../src/app/displayer/projects/projects.component.html
// module chunks = main